const initState = {
  UserInfo: {},
  Personality: "",
  firstSection: 0,
  secondSection: 0,
  thirdSection: 0,
  forthSection: 0,
};

const MbtiReducer = (state = initState, action) => {
  switch (action.type) {
    case "SET_MBTI_DATA":
      state = action.payload;
      return state;
    case "DEL_MBTI_DATA":
      state = initState;
      return state;
    default:
      return state;
  }
};

export default MbtiReducer;
